import { render, staticRenderFns } from "./outbound.vue?vue&type=template&id=54b66b12&scoped=true"
import script from "./outbound.vue?vue&type=script&lang=js"
export * from "./outbound.vue?vue&type=script&lang=js"
import style0 from "./outbound.vue?vue&type=style&index=0&id=54b66b12&prod&style=true&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b66b12",
  null
  
)

export default component.exports